const landingDictIT = {
  home: "Inizio",
  benefits: "Benefici",
  benefitsExplanation:
    "La nostra piattaforma è uno strumento moderno, facilmente accessibile e redditizio.",
  firstBenefit: "Maggiore integrazione commerciale",
  secondBenefit: "Economia più leggera e più potente",
  thirdBenefit: "Opportunità di profitto istantaneo e costante",
  fourthBenefit: "Generare credito",
  features: "Caratteristiche",
  howItWorks: "Come funziona",
  meetOurPlans: "Scopri i nostri piani",
  join: "I nostri piani",
  plans: "Piani",
  login: "Accedere",
  whatIsIt: "Il marketplace che ti premia sempre",
  whatIsItExplanation:
    "Extraconomy è una piattaforma on-line di economia cooperativa e partecipativa con un sistema di ricompense e di geolocalizzazioni che permette a privati e aziende di accrescere il proprio potere economico e la propria rete di clienti di forma automatica e progressiva, attraverso le varie attività svolte sul marketplace.",
  why: "Perchè?",
  greaterBusiness: "Maggiore integrazione aziendale",
  lighterPowerful: "Economia più leggera e più potente",
  instantProfit: "Opportunità di guadagno istantanea e costante per tutti",
  genCredit: "Genera credito",
  whyShould: "Perché dovrei aderire ad Extraconomy?",
  seeBelow: "Vedi sotto le risorse della nostra rete sociale ed economica:",
  extracredit: "Ottieni Crediti",
  extracoinExplanation:
    "Registrati dall'APP e guadagna Extracredit per acquistare e/o condividere con i tuoi amici.",
  indicate: "Guadagna Ricompense",
  youMayGain: "Indirizza gli utenti alla tua rete e guadagna sempre più crediti e denaro reale.",
  economicNetwork: "Circolo Economico",
  networkOfUsers:
    "Crea automaticamente una rete di utenti per acquistare e vendere prodotti e servizi.",
  transactionSafety: "Sicurezza delle Transazioni",
  ourPlatform:
    "La nostra piattaforma è robusta e sicura. Puoi acquistare, vendere e trasferire denaro in modo sicuro.",
  findEverything: "Trova tutto ciò di cui hai bisogno",
  weHavePowerfulTool:
    "Abbiamo un potente strumento per trovare il prodotto che desideri acquistare in pochi clic.",
  buyerReviews: "Recensioni degli Acquirenti",
  checkTheReviews:
    "Controlla le recensioni degli utenti che hanno acquistato il prodotto che stai cercando.",
  geolocation: "Geolocalizzazione",
  effectiveTools: "Strumenti efficaci per far crescere automaticamente il tuo circolo economico.",
  exceptionalTrading: "Affari eccezionali",
  saferMoreFrequent: "Scambi più sicuri, frequenti e vantaggiosi.",
  economicInfluence: "Influenza economica",
  sellFaster: "Con il Cashback velocizzi le vendite e acquisti più facilmente, guadagnando sempre.",
  howItWorksExplanation:
    "Ricevi premi per ogni attività che si svolge sulla piattaforma, sotto forma di denaro e crediti che possono essere utilizzati all'interno del sistema come complemento economico negli scambi commerciali.",
  joinExtraconomy: "Unisciti ad Extraconomy.",
  belowArePlans: "Di seguito sono riportati i tipi di piani disponibili sul nostro servizio.",
  contactWhatTele:
    "Per info sul progetto e sull' apertura di mercato per Partners e Managers in un Paese, scrivi presso i seguenti contatti di Whatsapp e Telegram.",
  learnMore: "Scopri di piu'",
  doubts: "Dubbi? ",
  contactToUs: "Contattaci.",
  contact: "Contatto",
  scanQRCode: "Scansiona il QR Code qui sotto per contattarci tramite WhatsApp/Telegram:",
  highlights: "In evidenza",
  by: " di ",
  video: "Video",
  introVideo: "Video introduttivo sulla nostra piattaforma:",
  backToHomePage: "Torna alla Home Page",
  qrCodeExplanation:
    "Per info sul progetto e sull'apertura di mercato per Partners e Managers in un Paese, scrivi presso i seguenti contatti di Whatsapp e Telegram:",
  socialMedia: "Social Media",
  rightsReserved: "Tutti i Diritti Riservati",
  checkApp: "Controlla la nostra app",
  customerDescription: "solo per fare acquisti",
  partnerDescription: "Per vendite e acquisti",
  managerDescription: "E-commerce + Acquisti",
  benefitsExtracoinSection: "Vantaggi per l'acquisto del nostro token Extracoin EXC",
  extracoinBenefitTitle1: "2.000 Extracoin: diventa Partner di Extraconomy!",
  extracoinBenefitDescription1:
    "I possessori di 2.000 Extracoin ricevono un buono gratuito per diventare Partner del Marketplace Extraconomy. Unisciti alla rivoluzione e partecipa attivamente alla definizione del futuro dell'economia digitale.",
  extracoinBenefitTitle2: "5.000 Extracoin: sblocca lo status di Seller su Extraconomy!",
  extracoinBenefitDescription2:
    "I possessori di 5.000 Extracoin vengono premiati con un voucher gratuito per diventare Sellers sulla piattaforma Extraconomy. Mostra i tuoi prodotti e servizi a un pubblico globale.",
  extracoinBenefitTitle3: "15.000 Extracoin: ottieni lo status di Manager della tua Extraconomy!",
  extracoinBenefitDescription3:
    "I possessori di 15.000 Extracoin ricevono un buono esclusivo per diventare Manager di Extraconomy. Immergiti nell'universo gestionale e contribuisci alla crescita dell'intero ecosistema.",
  voucherExtracoinText1: "Hai già un ",
  clickHere: "Clicca qui",
  andRegister: "e registrati",
  voucherEmptyError: "Il campo del voucher non può essere vuoto.",
  extracoinVoucherError: "Il voucher inserito non è valido.",
  startsWith: "Inizia con",
  contains: "Contiene",
  notContains: "Non contiene",
  endsWith: "Termina com",
  equals: "Equivale",
  notEquals: "Non uguali",
  noFilter: "Senza Filtro",
  joinTheLaunchpad: "Unisciti al Launchpad del nostro token Extracoin su Cryptosmart!",
  popupDesc:
    "Acquistando i token EXC ad un prezzo speciale, riceverai in cambio un voucher gratuito per aprire un negozio online sul marketplace Extraconomy, attiva la tua rendita giornaliera!",
  exclusiveBenefits: "Vantaggi esclusivi",
  popupPartnerTitle: "Diventa Partner!",
  popupPartnerDesc:
    "*Acquistando un minimo di 2.000 Extracoin riceverai in omaggio un voucher per aprire un punto vendita sul marketplace Extraconomy.",
  popupSellerTitle: "Sblocca il profilo del Seller!",
  popupSellerDesc:
    "*Acquistando almeno 5.000 Extracoin riceverai in omaggio un voucher per aprire un e-commerce sulla piattaforma Extraconomy.",
  popupManagerTitle: "Raggiungi lo stato di Manager!",
  popupManagerDesc:
    "*Acquistando un minimo di 15.000 Extracoin riceverai un voucher esclusivo per aprire un negozio online su Extraconomy con tutti i vantaggi inclusi.",
  promotionValidUntilEndLaunchpad: "Promozione valida fino alla fine del Launchpad",
  downloadAppAndEarn: "Scarica l'app ora e guadagna 20 euro di credito promozionali",
  frequentlyAskedQuestion: "Domande frequenti",
  faqTitle1: "La piattaforma Extraconomy è sicura?",
  faqAnswer1:
    "Sì, disponiamo di un team tecnico specializzato nella sicurezza delle informazioni. Tutti i contenuti, i dati e le operazioni finanziarie sulla piattaforma sono protetti da vari livelli di sicurezza, in questo modo possiamo mitigare il più possibile qualsiasi tipo di attacco informatico che possa verificarsi.",
  faqTitle2: "Come posso partecipare alla piattaforma?",
  faqAnswer2:
    "Se hai scoperto Extraconomy tramite qualcuno, loro sanno come farti entrare sulla piattaforma. In caso contrario, scarica la nostra App e iscriviti inserendo i tuoi dati per accedere direttamente allo Shop. Riceverai un credito di benvenuto da utilizzare nei tuoi futuri acquisti!",
  faqTitle3: "Ci sono spese di registrazione per poter vendere i miei prodotti o servizi?",
  faqAnswer3:
    "Sì, per avere uno spazio per la tua vetrina o per il tuo e-commerce esistono 3 piani di vendita con valori e vantaggi diversi a seconda delle esigenze di ciascun utente privato e aziendale. Puoi scoprire i Piani direttamente qui su questo sito.",
  faqTitle4:
    "Quando svolgo un'attività promozionale e di vendita sulla piattaforma Extraconomy ho un rapporto di lavoro?",
  faqAnswer4:
    "No, se hai aderito ad uno dei 3 piani di vendita sarai un lavoratore autonomo e pienamente responsabile delle tue spese. Solo se decidi di lavorare con noi come Promoter riceverai un contratto di Incaricato alle Vendite.",
  faqTitle5: "Come posso richiedere la cancellazione del mio account? ",
  faqAnswer5:
    "cancellare il tuo account Extraconomy dovrai semplicemente accedere nella tua Area Personale e poi su Modifica Profilo richiedere la cancellazione dell'account senza ulteriori costi. In alternativa, puoi inviare un messaggio Whatsapp al numero +39 351 767 0019 con oggetto “Cancellazione Account”.",
  faqTitle6: "Sono nuovo sulla piattaforma, c'è qualche supporto? ",
  faqAnswer6:
    "Sì, abbiamo un supporto umanizzato e dedicato per aiutarti ogni volta che ne hai bisogno attraverso i canali di Whatsapp e Telegram che trovi tra i nostri contatti qui sul sito.",
  faqTitle7: "Ho fornito un'e-mail errata, e adesso?",
  faqAnswer7:
    "Per cambiare la tua email dovrai inviare un messaggio WhatsApp al numero +39 351 767 0019 con oggetto “Cambia email”, indicando tutti i dati di registrazione utilizzati in fase di registrazione e l’indirizzo email corretto.",
  faqTitle8: "Quali sono le opzioni di pagamento?",
  faqAnswer8:
    "Attraverso PayPal, il nostro gateway di pagamento internazionale, puoi pagare il tuo ordine con carta di credito, carta di debito o conto bancario.",
  faqTitle9: "Quanto costa la spedizione nella mia regione?",
  faqAnswer9:
    "Per questo calcolo, il modo più semplice è simulare il tuo ordine. Scegli gli articoli con la Spedizione a Pagamento, aggiungili al carrello e completa l'acquisto, inserisci correttamente i tuoi dati (molto importante) e al termine dell'ordine il sito ti indicherà il costo di spedizione corretto. Se stai solo simulando, non fare clic su Checkout e non si tradurrà in alcun acquisto reale da parte tua. Modifica poi gli articoli e le quantità per vedere le differenze, sentiti libero.",
  faqTitle10: "Come funzionano i crediti acquisiti su Extraconomy?",
  faqAnswer10:
    "I crediti interni si acquisiscono attraverso le varie attività svolte sulla piattaforma (Iscrizioni, Compra-Vendite e Condivisioni) sottoforma di caschback, premi e bonus, che potranno essere utilizzati di forma complementare negli acquisti all'interno della piattaforma o nelle attività di marketing in base ai termini di utilizzo previsti per ogni profilo utente.",
  faqTitle11:
    "Come posso monitorare e gestire i miei pagamenti, le mie commissioni e i miei bonus ricevuti su Extraconomy? ",
  faqAnswer11:
    "Quando ti registri via Web e via App, ricevi un ufficio virtuale nella tua Area Personale dove potrai tenere traccia di tutte le tue entrate finanziarie dirette e di quelle derivanti dal tuo circolo economico.",
  faqTitle12: "Come ricevo le mie entrate economiche? ",
  faqAnswer12:
    "Le entrate economiche dirette e indirette vengono accreditate sul tuo conto PayPal, che dovrai inserire nella tua Area Personale. Se non hai un conto PayPal, puoi crearne uno gratuitamente su www.paypal.com.",
  SeeTheRegulationsHere: "Vedi qui il regolamento",
  joinTheLaunchpadButton: "Unisciti al Launchpad",
  tax: "Tariffa",
  workWithUs: "Lavora con noi",
  jobOpportunity: "Opportunità lavorativa",
  workWithUsText1:
    "Il sistema Extraconomy offre la possibilità di partecipare allo sviluppo on-line e territoriale attraverso figure chiave (web promoter, ambassador, sales agent, micro-influencer, market affiliates) che potranno beneficiare automaticamente di un sistema provvigionale esclusivo, scalabile e gratificante.",
  freePlan: "Gratuito",
  salesRepresentativeContract: "Contratto di incaricato alla vendita",
  earnCommissionsAndCredits: "Guadagna commissioni e crediti",
  developYourNetwork: "Sviluppa il tuo network",
  financialCareerAwards: "Premi economici alla carriera",
  resources: "Risorse",
  blog: "Blog",
  toTheStore: "ACCEDI AL NEGOZIO",
  revolutionizeWithExtraconomy: "Rivoluziona l'economia con Extraconomy",
  revolutionizeWithExtraconomyDescription:
    "Trasforma le tue spese quotidiane in guadagni e partecipa a un'economia più sostenibile.",
  iWantToStart: "Voglio rivoluzionare l'economia.",
  extrapayBalance: "Saldo Extrapay",
  extracreditBalance: "Saldo Extracredit",
  viewCashback: "Visualizza l'estratto del cashback",
  partnerPlan: "Piano Partner",
  empowerYourBusiness: "Potenziamo il tuo business",
  empowerYourBusinessDescription:
    "Extraconomy è un modello economico che unisce tecnologia, comunità e cooperazione. Abbiamo creato un sistema innovativo che amplifica il potere economico delle persone e sostiene le attività locali.",
  comercialIntegration: "Maggiore integrazione commerciale",
  comercialIntegrationDescription:
    "I nostri strumenti potenziano l'integrazione tra negozi e clienti, basandosi sul modello di geolocalizzazione.",
  powerfulEconomy: "Un'economia più leggera e potente",
  powerfulEconomyDescription:
    "Rafforziamo l'economia locale e aiutiamo i commerci locali a guadagnare maggiore visibilità.",
  instantProfitDescription:
    "Con il circolo economico attivo, inizi a guadagnare denaro dal momento della registrazione e lo ampli con acquisti e segnalazioni.",
  generateCredit: "Genera più credito",
  generateCreditDescription: "Puoi guadagnare denaro mentre fai gli acquisti di tutti i giorni.",
  advantages: "Abbiamo molti vantaggi per te",
  createAnAccountForFree: "Crea il tuo account gratuito e scopri tutti i vantaggi che",
  createAnAccountForFree2: "può offrirti",
  geolocalization: "Geolocalizzazione",
  geolocalizationDescription: "Scopri servizi e aziende locali e rafforza la tua regione.",
  coperativeEconomy: "Economia cooperativa",
  coperativeEconomyDescription:
    "Partecipa attivamente alla costruzione di un futuro più inclusivo.",
  cashback: "Cashback automatico",
  cashbackDescription: "Risparmia e accumula crediti su tutti i tuoi acquisti.",
  pension: "Welfare Integrativo",
  pensionDescription: "Assicura automaticamente il tuo benessere con i risparmi quotidiani.",
  contactUs: "Contattaci su WhatsApp",
  manyAdvantages: "Ci sono tanti vantaggi!",
  monetaryAlternatives:
    "Usa anche la nostra alternativa monetaria, risparmierai di più pagando con ",
  monetaryAlternatives2: "l'utility-token Extracoin!",
  scrollDown: "Continua a esplorare",
  exclusiveResources: "RISORSE ESCLUSIVE",
  whyExtraconomy: "Perché dovresti unirti a Extraconomy?",
  whyExtraconomyDescription:
    "Con le risorse della nostra rete sociale ed economica, puoi potenziare i tuoi guadagni. Scopri tutti i vantaggi di Extraconomy e unisciti a noi.",
  newAcquisition: "Nuovo acquisto",
  newSale: "Nuova vendita",
  localSales: "Vendita locale con ritiro.",
  descExtracredit:
    "Registrati e ottieni Extracredit (consulta le condizioni). Usa il credito per acquistare e/o condividerlo con i tuoi amici.",
  descEconomicNetwork:
    "Crea automaticamente una rete di utenti per acquistare e vendere prodotti e servizi.",
  descTransactionSafety:
    "La nostra piattaforma e robusta e sicura. Puoi acquistare, vendere e trasferire denaro in modo sicuro.",
  descFindEverything:
    "Abbiamo un potente strumento per trovare il prodotto che desideri acquistare in pochi clic.",
  plansAdvantages: "VANTAGGIO IN OGNI PIANO",
  chooseYourPlanTitle: "Scegli il piano che meglio si adatta al tuo profilo.",
  chooseYourPlanDescription:
    "Scopri i nostri piani, scegli quello che meglio si adatta al tuo profilo e unisciti a Extraconomy.",
  noMonthlyFees: "SENZA TASSE MENSILI",
  noMonthlyPaymentsDesc: "Non dovrai effettuare pagamenti mensili.",
  partner: "PARTNER",
  naturalPerson: "Persona fisica",
  salesPlan: "Piano di vendita",
  selectPlan: "SELEZIONA",
  legalOrNaturalPerson: "Persona fisica / Persona giuridica",
  featureShowcase: "Vetrina online",
  featureEconomicNetwork: "Circolo economico",
  featureActiveComission: "Commissione attiva",
  featureEcommerce: "E-commerce personale",
  featureOnlineStore: "Negozio online",
  featureGeolocation: "Geolocalizzazione attiva",
  featureEvrythingIncluded: "Tutto incluso",
  mostPopular: "più prescelto",
  doubtsAboutPlans: "Hai dubbi su quale sia il piano migliore?",
  doubtsAboutPlansDesc:
    "Invia un messaggio al nostro servizio clienti e ti aiuteremo a scegliere il piano migliore per il tuo profilo.",
  workWithUsSubtitle: "LAVORA CON NOI",
  workWithUsTitle: "Diventa un Promoter di Extraconomy e moltiplica i tuoi guadagni.",
  workWithUsDescription:
    "Il sistema Extraconomy offre la possibilità di partecipare allo sviluppo online e territoriale attraverso figure chiave (promoter web, ambasciatore, agente commerciale, micro-influencer, affiliati di mercato), che beneficeranno automaticamente di un sistema di commissioni esclusivo, scalabile e gratificante.",
  doYouWantToWork: "Vuoi diventare un Promoter?",
  extracredits: "Ricevi € 500 in crediti extra.",
  moreBonus: "Bonus",
  moreBonusesDescription: "Premi per la carriera finanziaria.",
  recurrence: "Ricorrenza",
  recurrenceDescription: "Sviluppa la tua rete e aumenta la tua ricorrenza di guadagni.",
  comissions: "Commissioni",
  comissionsDescription: "Guadagna commissioni e crediti.",
  clarify: "Chiarisci i tuoi dubbi",
  frequentlyAskedQuestionDescription:
    "Abbiamo raccolto alcune domande e risposte che possono aiutarti nella tua scelta.",
  doubtsDescription: "Invia un messaggio al nostro team.",
  joinUs: "Entra a far parte",
  joinUsDescription: "Registrati e trasformiamo l'economia, insieme.",
  talkWithUs: "Parla con il nostro team.",
  talkWithUsDescription: "Parla con il nostro team commerciale.",
  needHelp: "Hai bisogno di aiuto?",
  downloadApp: "Scarica l'app",
  call: "Chiama",
  callDescription: "Mettiti in contatto con noi",
  buyInWhatsapp: "Acquista su WhatsApp",
  buyInWhatsappDescription: "Veloce e sicuro",
  assistance: "Centro di assistenza",
  assistanceDescription: "Rispondi ai tuoi dubbi",
  followUs: "Segui i nostri canali ufficiali",
  shippingMethods: "Modalità di spedizione",
  partners: "Partners",
  discoverExtraconomy: "Scopri Extraconomy",
  rewardsProgram: "Sistema di ricompensa",
  makeMoneyWithUs: "Guadagna denaro",
  sellWithUs: "Vendi con noi",
  becomeAffiliate: "Diventa un promoter",
  ourPolicies: "Le nostre politiche",
  shippingPolicy: "Politica di consegna",
  privacyPolicy: "Politica sulla privacy",
  returnPolicy: "Politica di rimborso",
  returnsAndRefunds: "Resi e sostituzioni",
  partnerPlanDescription: "Per chi inizia a vendere online.",
  sellerPlanDescription: "Per chi vuole incrementare le proprie vendite.",
  managerPlanDescription: "Per chi vuole ampliare il proprio business.",
  planSeller: "SELLER",
  register: "Registrati",
  activateYourDigitalAccess: "Attiva il tuo accesso digitale",
  seoDescription: "Una piattaforma innovativa on-line di economia cooperativa e circolare.",

  // --- Landing page redesign translations (lp2*) ---
  lp2HeroTitle: "Rivoluzioniamo insieme l'economia?",
  lp2HeroDescription: "Trasforma le tue spese quotidiane in guadagni e partecipa a un'economia più sostenibile, costruita da te, insieme a chi ti circonda.",
  lp2HeroCta: "Voglio far parte di questa economia.",
  lp2HeroMicrocopy: "Nessuna quota di iscrizione per te. Nessuna clausola nascosta.",
  lp2LocalPartner: "Partner locale",
  lp2ComoFuncionaEyebrow: "Come funziona",
  lp2ComoFuncionaTitle: "Acquista, ricevi vantaggi e usali di nuovo.",
  lp2ComoFuncionaDescription: "Acquisti nella rete, ricevi vantaggi e puoi usarli per nuovi acquisti. Nel frattempo, le attività vicine guadagnano più movimento.",
  lp2Step1Label: "Acquista",
  lp2Step1Title: "Acquista nella rete",
  lp2Step1Desc: "Trova negozi fisici e venditori online di Extraconomy.",
  lp2Step2Label: "Ricevi",
  lp2Step2Title: "Il tuo acquisto genera vantaggi",
  lp2Step2Desc: "Ricevi cashback in Extracredit e vantaggi tramite Extrapay.",
  lp2Step3Label: "Usa",
  lp2Step3Title: "Usalo nel prossimo acquisto",
  lp2Step3Desc: "Il tuo saldo resta visibile nel portafoglio e può tornare per nuovi acquisti.",
  lp2Step4Label: "Falla circolare",
  lp2Step4Title: "La rete si rafforza",
  lp2Step4Desc: "Più acquisti attirano nuove attività e aumentano le opzioni per tutti.",
  lp2ChoosePathEyebrow: "Scegli come partecipare",
  lp2ChoosePathTitle: "Inizia da ciò che ha più senso per te.",
  lp2ChoosePathDescription: "Acquista, vendi, segnala attività o crea una tua rete. I dettagli compaiono quando vuoi saperne di più.",
  lp2Card1Eyebrow: "Per chi acquista",
  lp2Card1Title: "Acquistare",
  lp2Card1Desc: "Acquista nella rete e ricevi cashback.",
  lp2Card1Cta: "Scopri di più",
  lp2Card2Eyebrow: "Per chi vende",
  lp2Card2Title: "Vendere",
  lp2Card2Desc: "Ottieni una vetrina, un negozio online o una presenza geolocalizzata.",
  lp2Card2Cta: "Vedi le opzioni",
  lp2Card3Eyebrow: "Per chi connette",
  lp2Card3Title: "Promuovere",
  lp2Card3Desc: "Presenta nuove attività e aiuta la rete a crescere.",
  lp2Card3Cta: "Scopri il programma Promoter",
  lp2Card4Eyebrow: "Per le aziende",
  lp2Card4Title: "Offrire vantaggi",
  lp2Card4Desc: "Crea vantaggi per dipendenti, clienti e partner.",
  lp2Card4Cta: "Scopri le soluzioni",
  lp2HighlightEyebrow: "Per le organizzazioni",
  lp2HighlightTitle: "Creare una rete",
  lp2HighlightDesc: "Ottieni un ambiente tutto tuo con la tecnologia Extraconomy.",
  lp2HighlightCta: "Scopri White Label",
  lp2NegocioEyebrow: "PER PARTNER, SELLER E MANAGER",
  lp2NegocioTitle: "Abbiamo tanti vantaggi per te",
  lp2NegocioDescription: "Crea il tuo account e scopri tutti i vantaggi che Extraconomy può offrire alla tua attività, con un sistema che unisce tecnologia, comunità e cooperazione.",
  lp2NegocioItem1Title: "Maggiore integrazione commerciale",
  lp2NegocioItem1Desc: "Colleghiamo negozi e clienti sulla base di un modello di geolocalizzazione.",
  lp2NegocioItem2Title: "Un'economia più veloce e potente",
  lp2NegocioItem2Desc: "Rafforziamo il commercio locale e aiutiamo le attività a guadagnare visibilità.",
  lp2NegocioItem3Title: "Profitto istantaneo e costante",
  lp2NegocioItem3Desc: "Guadagni fin dalla registrazione e cresci con ogni vendita e segnalazione.",
  lp2NegocioItem4Title: "Genera più credito",
  lp2NegocioItem4Desc: "Guadagna mentre fai i tuoi acquisti quotidiani.",
  lp2StoreEyebrow: "PER NEGOZI FISICI",
  lp2StoreTitle: "Diventa un esercizio convenzionato",
  lp2StoreDescription: "Metti il tuo negozio sulla mappa di Extraconomy e fatti trovare da chi è già vicino a te, con iscrizione gratuita e la fascia di cashback più alta dell'ecosistema.",
  lp2StoreItem1Title: "Iscrizione 100% gratuita",
  lp2StoreItem1Desc: "Nessun costo di registrazione per mettere il tuo negozio fisico sulla mappa.",
  lp2StoreItem2Title: "Geolocalizzazione attiva",
  lp2StoreItem2Desc: "Ricevi automaticamente i clienti più vicini al tuo negozio.",
  lp2StoreItem3Title: "Cashback dall'1% al 50%",
  lp2StoreItem3Desc: "La fascia di cashback più alta tra tutti i profili dell'ecosistema.",
  lp2StoreItem4Title: "Negozio online quando vuoi",
  lp2StoreItem4Desc: "Attiva un e-commerce tutto tuo alle condizioni del piano Seller, quando ha senso.",
  lp2RecursosEyebrow: "RISORSE SPECIALI · PER TUTTI",
  lp2RecursosTitle: "Il potenziale che è già tuo fin dal primo clic",
  lp2RecursosDescription: "Che tu compri, venda o gestisca un'attività, queste funzionalità sono già disponibili non appena entri in Extraconomy.",
  lp2RecursosItem1Title: "Geolocalizzazione",
  lp2RecursosItem1Desc: "Scopri servizi e attività locali e sostieni la tua zona.",
  lp2RecursosItem2Title: "Economia cooperativa",
  lp2RecursosItem2Desc: "Partecipa attivamente alla costruzione di un futuro più inclusivo.",
  lp2RecursosItem3Title: "Sicurezza nelle transazioni",
  lp2RecursosItem3Desc: "Acquista, vendi e trasferisci denaro in sicurezza.",
  lp2RecursosItem4Title: "Trova tutto ciò di cui hai bisogno",
  lp2RecursosItem4Desc: "Uno strumento potente per trovare ciò che desideri in pochi clic.",
  lp2RecursosCashbackLabel: "16,00 € di cashback",
  lp2RecursosLocalSaleLabel: "Vendita locale con ritiro",
  lp2EcoTitle: "Più persone partecipano, più forte diventa il commercio locale",
  lp2EcoDescription: "La geolocalizzazione non serve solo a trovare: reindirizza i consumi vicino a te, in un ciclo che si autoalimenta.",
  lp2EcoStep1Title: "Tu acquisti localmente",
  lp2EcoStep1Desc: "Vicino a casa, con cashback garantito.",
  lp2EcoStep2Title: "Il venditore guadagna visibilità",
  lp2EcoStep2Desc: "Grazie alla geolocalizzazione, vicino a chi già acquista da lui.",
  lp2EcoStep3Title: "Più partner si iscrivono",
  lp2EcoStep3Desc: "Attratti dal movimento generato nella zona.",
  lp2EcoStep4Title: "Più opzioni per te",
  lp2EcoStep4Desc: "E il ciclo ricomincia, sempre più forte.",
  lp2ContinueExploring: "Continua a esplorare",
  lp2Bar1Title: "Potenzia la tua attività",
  lp2Bar1Text: "Scopri cosa cambia per chi ha un'attività su Extraconomy.",
  lp2Bar2Title: "E questo potenziale non è solo per chi vende.",
  lp2Bar2Text: "È per chiunque entri in Extraconomy, fin dal primo clic.",
  lp2Bar3Title: "E più persone partecipano, più forte diventa questo ciclo.",
  lp2Bar3Text: "Scopri come ogni acquisto locale alimenta il passo successivo.",
  lp2Bar4Title: "Ora hai capito come tutto si collega.",
  lp2Bar4Text: "È il momento di chiudere il cerchio e scegliere il tuo posto.",
  lp2Bar5Title: "Vuoi andare oltre e moltiplicare il tuo ruolo in questa economia?",
  lp2Bar5Text: "Scopri l'opportunità di diventare un Promoter.",
  lp2PromotorEyebrow: "LAVORA CON NOI",
  lp2PromotorTitle: "Diventa un Promoter di Extraconomy e moltiplica i tuoi guadagni",
  lp2PromotorDescription: "Partecipa allo sviluppo online e territoriale della rete. Come Promoter, metti in contatto persone e attività e ricevi commissioni su vendite e collaborazioni reali.",
  lp2PromotorInfoBox: "I tuoi guadagni derivano da vendite e collaborazioni reali: non c'è alcun guadagno per il semplice invito di persone.",
  lp2PromotorCard1Title: "Connetti le persone",
  lp2PromotorCard1Desc: "Avvicina persone e attività alla rete.",
  lp2PromotorCard2Title: "Connetti le attività",
  lp2PromotorCard2Desc: "Amplia la presenza territoriale della rete.",
  lp2PromotorCard3Title: "Sviluppa la rete",
  lp2PromotorCard3Desc: "Rafforza relazioni commerciali reali.",
  lp2PromotorCard4Title: "Guadagna con le vendite",
  lp2PromotorCard4Desc: "Commissioni legate a vendite e collaborazioni reali.",
  lp2Profile: "Profilo",
  lp2BadgeProSilver: "Pro Silver",
  lp2BadgeMostPopular: "Start Seller",
  lp2BadgeGeoGold: "Geo Gold",
  lp2BadgeFree: "GRATIS",
  lp2CashbackPartner: "Cashback dall'1% al 15%",
  lp2CashbackSeller: "Cashback dall'1% al 25%",
  lp2CashbackManager: "Cashback dall'1% al 35%",
  lp2CashbackCustomer: "Cashback dall'1% al 5%",
  lp2StorePlanDesc: "Il tuo negozio fisico, certificato sulla mappa.",
  lp2CustomerPlanDesc: "Per chi vuole acquistare e ricevere vantaggi.",
  lp2FeatureFreeSignup: "Iscrizione gratuita",
  lp2FeatureGeoAccount: "Account geolocalizzato",
  lp2FeatureMapCertification: "Certificazione sulla mappa",
  lp2FeatureEligibleCashback: "Cashback sugli acquisti idonei",
  lp2FeatureExtracreditWallet: "Portafoglio Extracredit",
  lp2CtaSelect: "Seleziona",
  lp2CtaCertifyStore: "Certifica il negozio",
  lp2CtaCreateAccount: "Crea account",
  lp2PlansEyebrow: "SCEGLI IL TUO PROFILO",
  lp2PlansTitle: "Trova il profilo più adatto a te",
  lp2PlansDescription: "Customer e Store sono gratuiti. Partner, Seller e Manager prevedono dei Piani di Vendita a pagamento per accompagnare le diverse fasi della tua attività on-line. Anche il profilo Promoter è gratuito.",
  lp2PlansCalloutTitle: "Profili gratuiti disponibili",
  lp2PlansCalloutDesc: "Customer e Store non pagano per iniziare.",
  lp2Faq1Q: "Come posso partecipare alla piattaforma?",
  lp2Faq1A: "Basta creare il tuo account gratuito — come Customer, per acquistare e guadagnare cashback, oppure registrando la tua attività se vuoi vendere.",
  lp2Faq2Q: "La piattaforma Extraconomy è sicura?",
  lp2Faq2A: "Sì. Tutte le transazioni passano attraverso un sistema di sicurezza robusto e il tuo saldo in Extracredit è sempre visibile nel tuo portafoglio.",
  lp2Faq3Q: "Ci sono costi di registrazione per vendere?",
  lp2Faq3A: "Customer e Store hanno un'iscrizione gratuita. Partner, Seller e Manager prevedono una quota annuale, in base alla dimensione dell'attività.",
  lp2Faq4Q: "Cos'è Extracoin?",
  lp2Faq4A: "È il nostro token di utilità. Usarlo riduce la commissione della piattaforma sugli acquisti e può essere scambiato su exchange collegati.",
  lp2Faq5Q: "Come funziona la rete di Promoter?",
  lp2Faq5A: "I Promoter presentano l'ecosistema a nuovi partner e guadagnano commissioni su affari reali, mai per il semplice invito di persone.",
  lp2FooterColPerfis: "Profili",
  lp2FooterColGanheDinheiro: "Guadagna",
  lp2FooterColPoliticas: "Le nostre politiche",
  lp2LinkDescubra: "Scopri Extraconomy",
  lp2LinkEmpresas: "Extraconomy per le Aziende",
  lp2LinkTecnologia: "Tecnologia come Servizio",
  lp2LinkMoedas: "Valute dell'ecosistema",
  lp2LinkAjuda: "Centro Assistenza",
  lp2LinkPerfisPlanos: "Profili e piani",
  lp2LinkSejaPromotor: "Diventa un Promoter",
  lp2LinkPrivacidade: "Informativa sulla privacy",
  lp2LinkTermos: "Termini di utilizzo",
  lp2FooterAppHeading: "Scarica la nostra app",
  lp2CustSeoDescription: "Acquista nella rete Extraconomy e monitora cashback e vantaggi in un account gratuito.",
  lp2CustBadge: "Customer · gratuito",
  lp2CustH1: "Acquista nella rete e ricevi indietro parte del valore.",
  lp2CustHeroDesc: "Il tuo account è gratuito. Trovi le attività di Extraconomy, acquisti e monitori i tuoi vantaggi in un unico posto.",
  lp2CustCta1: "Crea il mio account",
  lp2CustCta2: "Capire i vantaggi",
  lp2CustBenefitsEyebrow: "Per la tua vita quotidiana",
  lp2CustBenefitsTitle: "Acquistare diventa più semplice quando il vantaggio è chiaro.",
  lp2CustBenefitsDesc: "Acquisti come sei già abituato a fare. La differenza è che parte di questa esperienza torna a te all'interno della rete.",
  lp2CustBenefit1Title: "Trova attività vicine",
  lp2CustBenefit1Desc: "Scopri negozi, prodotti e servizi che fanno parte di Extraconomy.",
  lp2CustBenefit2Title: "Ricevi cashback",
  lp2CustBenefit2Desc: "Negli acquisti idonei, parte del valore torna a te in Extracredit.",
  lp2CustBenefit3Title: "Monitora tutto nel portafoglio",
  lp2CustBenefit3Desc: "Visualizza saldi e vantaggi senza dover memorizzare regole.",
  lp2CustExtracreditTitle: "Il tuo cashback diventa facile da capire.",
  lp2CustExtracreditDesc: "Quando un acquisto genera cashback, il valore appare come Extracredit. 1 Extracredit vale 1 Euro e può essere usato secondo le regole della rete.",
  lp2CustExtrapayLink: "Scopri Extrapay",
  lp2CustPraticaLabel: "In pratica",
  lp2CustStep1Title: "Tu acquisti",
  lp2CustStep1Desc: "In un negozio o venditore della rete.",
  lp2CustStep2Title: "Il vantaggio appare",
  lp2CustStep2Desc: "Il cashback e altri vantaggi vengono associati al tuo account.",
  lp2CustStep3Title: "Lo usi quando ha senso",
  lp2CustStep3Desc: "Il portafoglio mostra cosa è disponibile.",
  lp2CustFaqEyebrow: "Domande rapide",
  lp2CustFaqTitle: "Prima di continuare.",
  lp2CustFaqDesc: "Guarda solo ciò che di solito genera dubbi in questa fase.",
  lp2CustFaq1Q: "Devo pagare per creare un account?",
  lp2CustFaq1A: "No. Customer è il profilo gratuito per chi acquista nella rete.",
  lp2CustFaq2Q: "Devo capire Extrapay ed EXC prima di acquistare?",
  lp2CustFaq2A: "No. Puoi iniziare acquistando e scoprire queste funzionalità solo quando compariranno nella tua esperienza.",
  lp2CustFaq3Q: "Dove vedo i miei vantaggi?",
  lp2CustFaq3A: "I vantaggi sono associati al tuo account e vengono mostrati nel portafoglio e nelle aree corrispondenti della piattaforma.",
  lp2CustCtaTitle: "Pronto per iniziare?",
  lp2CustCtaDesc: "Crea il tuo account e scopri Extraconomy nella parte che conta di più: usarla.",
  lp2CustCtaButton: "Crea account gratuito",
  lp2PartnerSeoDescription: "Piano Partner ProSilver per iniziare a vendere online su Extraconomy.",
  lp2PartnerBadge: "Partner · ProSilver",
  lp2PartnerPill: "ProSilver",
  lp2PartnerH1: "Inizia a vendere online con la tua vetrina.",
  lp2PartnerHeroDesc: "Per chi vuole muovere il primo passo nelle vendite online all'interno di Extraconomy.",
  lp2PartnerCta1: "Scegli Partner",
  lp2PartnerCta2: "Confronta i piani",
  lp2PartnerBenefitsEyebrow: "Cosa ricevi",
  lp2PartnerBenefitsTitle: "Un piano pensato per il momento della tua attività.",
  lp2PartnerBenefitsDesc: "Guarda prima ciò che cambia davvero nella tua operazione. I dettagli completi sono disponibili quando ti servono.",
  lp2PartnerBenefit1Title: "La tua vetrina nella rete",
  lp2PartnerBenefit1Desc: "Presenta prodotti e servizi in uno spazio tutto tuo.",
  lp2PartnerBenefit2Title: "Fino a 50 annunci",
  lp2PartnerBenefit2Desc: "Una capacità iniziale per organizzare la tua offerta senza eccessi.",
  lp2PartnerBenefit3Title: "Fai parte dell'ecosistema",
  lp2PartnerBenefit3Desc: "Vendi a persone che già frequentano la rete Extraconomy.",
  lp2PartnerStat1Label: "Capacità",
  lp2PartnerStat1Value: "Fino a 50 annunci",
  lp2PartnerStat2Label: "Registrazione",
  lp2PartnerStat2Value: "€150/anno",
  lp2PartnerStat3Label: "Rinnovo",
  lp2PartnerStat3Value: "€15/anno",
  lp2PartnerStatsDisclaimer: "Valori e condizioni devono essere confermati al momento della sottoscrizione. Questa pagina presenta la struttura commerciale del piano in forma riassuntiva.",
  lp2PartnerFaqEyebrow: "Domande rapide",
  lp2PartnerFaqTitle: "Prima di continuare.",
  lp2PartnerFaqDesc: "Guarda solo ciò che di solito genera dubbi in questa fase.",
  lp2PartnerFaq1Q: "Posso cambiare piano in seguito?",
  lp2PartnerFaq1A: "La struttura è stata organizzata per seguire la crescita della tua operazione. Consulta le condizioni vigenti per i cambi di piano.",
  lp2PartnerFaq2Q: "C'è una quota mensile?",
  lp2PartnerFaq2A: "I piani presentati prevedono addebito annuale e rinnovo annuale, secondo le condizioni di ciascuna modalità.",
  lp2PartnerFaq3Q: "Devo decidere adesso?",
  lp2PartnerFaq3A: "No. Confronta i piani e scegli solo quando le differenze avranno senso per la tua operazione.",
  lp2PartnerCtaTitle: "È questo il momento del Partner?",
  lp2PartnerCtaDesc: "Registrati e continua con i dati della tua operazione.",
  lp2PartnerCtaButton: "Scegli Partner",
  lp2SellerSeoDescription: "Piano Seller StartSeller per ampliare la tua operazione di vendita online.",
  lp2SellerBadge: "Seller · StartSeller",
  lp2SellerPill: "Più popolare",
  lp2SellerH1: "Vendi già online? Dai più spazio alla tua operazione.",
  lp2SellerHeroDesc: "Seller è per chi ha bisogno di ampliare catalogo e presenza senza complicare la routine.",
  lp2SellerCta1: "Scegli Seller",
  lp2SellerCta2: "Confronta i piani",
  lp2SellerBenefitsEyebrow: "Cosa ricevi",
  lp2SellerBenefitsTitle: "Un piano pensato per il momento della tua attività.",
  lp2SellerBenefitsDesc: "Guarda prima ciò che cambia davvero nella tua operazione. I dettagli completi sono disponibili quando ti servono.",
  lp2SellerBenefit1Title: "Catalogo più grande",
  lp2SellerBenefit1Desc: "Fino a 500 annunci per un'operazione che ha già guadagnato scala.",
  lp2SellerBenefit2Title: "Vendi all'interno della rete",
  lp2SellerBenefit2Desc: "Collega la tua offerta al marketplace Extraconomy.",
  lp2SellerBenefit3Title: "Più spazio per crescere",
  lp2SellerBenefit3Desc: "Una struttura intermedia per chi ha già una routine di vendite.",
  lp2SellerStat1Label: "Capacità",
  lp2SellerStat1Value: "Fino a 500 annunci",
  lp2SellerStat2Label: "Registrazione",
  lp2SellerStat2Value: "€350/anno",
  lp2SellerStat3Label: "Rinnovo",
  lp2SellerStat3Value: "€35/anno",
  lp2SellerStatsDisclaimer: "Valori e condizioni devono essere confermati al momento della sottoscrizione. Questa pagina presenta la struttura commerciale del piano in forma riassuntiva.",
  lp2SellerFaqEyebrow: "Domande rapide",
  lp2SellerFaqTitle: "Prima di continuare.",
  lp2SellerFaqDesc: "Guarda solo ciò che di solito genera dubbi in questa fase.",
  lp2SellerFaq1Q: "Posso cambiare piano in seguito?",
  lp2SellerFaq1A: "La struttura è stata organizzata per seguire la crescita della tua operazione. Consulta le condizioni vigenti per i cambi di piano.",
  lp2SellerFaq2Q: "C'è una quota mensile?",
  lp2SellerFaq2A: "I piani presentati prevedono addebito annuale e rinnovo annuale, secondo le condizioni di ciascuna modalità.",
  lp2SellerFaq3Q: "Devo decidere adesso?",
  lp2SellerFaq3A: "No. Confronta i piani e scegli solo quando le differenze avranno senso per la tua operazione.",
  lp2SellerCtaTitle: "È questo il momento del Seller?",
  lp2SellerCtaDesc: "Registrati e continua con i dati della tua operazione.",
  lp2SellerCtaButton: "Scegli Seller",
  lp2ManagerSeoDescription: "Piano Manager GeoGold per operazioni con catalogo ampio e portata territoriale.",
  lp2ManagerBadge: "Manager · GeoGold",
  lp2ManagerPill: "GeoGold",
  lp2ManagerH1: "Più portata per un'operazione che è già cresciuta.",
  lp2ManagerHeroDesc: "Manager riunisce risorse per attività con catalogo ampio e maggiori esigenze territoriali.",
  lp2ManagerCta1: "Scegli Manager",
  lp2ManagerCta2: "Confronta i piani",
  lp2ManagerBenefitsEyebrow: "Cosa ricevi",
  lp2ManagerBenefitsTitle: "Un piano pensato per il momento della tua attività.",
  lp2ManagerBenefitsDesc: "Guarda prima ciò che cambia davvero nella tua operazione. I dettagli completi sono disponibili quando ti servono.",
  lp2ManagerBenefit1Title: "Annunci illimitati",
  lp2ManagerBenefit1Desc: "Struttura un catalogo ampio senza un limite di annunci.",
  lp2ManagerBenefit2Title: "Presenza territoriale",
  lp2ManagerBenefit2Desc: "Le risorse di geolocalizzazione supportano operazioni con portata maggiore.",
  lp2ManagerBenefit3Title: "Operazione più completa",
  lp2ManagerBenefit3Desc: "Un livello pensato per strutture commerciali più mature.",
  lp2ManagerStat1Label: "Capacità",
  lp2ManagerStat1Value: "Annunci illimitati",
  lp2ManagerStat2Label: "Registrazione",
  lp2ManagerStat2Value: "€1.500/anno",
  lp2ManagerStat3Label: "Rinnovo",
  lp2ManagerStat3Value: "€150/anno",
  lp2ManagerStatsDisclaimer: "Valori e condizioni devono essere confermati al momento della sottoscrizione. Questa pagina presenta la struttura commerciale del piano in forma riassuntiva.",
  lp2ManagerFaqEyebrow: "Domande rapide",
  lp2ManagerFaqTitle: "Prima di continuare.",
  lp2ManagerFaqDesc: "Guarda solo ciò che di solito genera dubbi in questa fase.",
  lp2ManagerFaq1Q: "Posso cambiare piano in seguito?",
  lp2ManagerFaq1A: "La struttura è stata organizzata per seguire la crescita della tua operazione. Consulta le condizioni vigenti per i cambi di piano.",
  lp2ManagerFaq2Q: "C'è una quota mensile?",
  lp2ManagerFaq2A: "I piani presentati prevedono addebito annuale e rinnovo annuale, secondo le condizioni di ciascuna modalità.",
  lp2ManagerFaq3Q: "Devo decidere adesso?",
  lp2ManagerFaq3A: "No. Confronta i piani e scegli solo quando le differenze avranno senso per la tua operazione.",
  lp2ManagerCtaTitle: "È questo il momento del Manager?",
  lp2ManagerCtaDesc: "Registrati e continua con i dati della tua operazione.",
  lp2ManagerCtaButton: "Scegli Manager",
  lp2StoreSeoDescription: "Registra gratuitamente il tuo negozio fisico sulla mappa di Extraconomy.",
  lp2StoreBadge: "Store · gratuito",
  lp2StoreH1: "Metti il tuo negozio sulla mappa di Extraconomy.",
  lp2StoreHeroDesc: "Registra la tua attività fisica gratuitamente e rendila più facile da trovare per chi già fa parte della rete.",
  lp2StoreCta1: "Registra il mio negozio",
  lp2StoreCta2: "Scopri come funziona",
  lp2StoreBenefitsEyebrow: "Il tuo negozio nella rete",
  lp2StoreBenefitsTitle: "Più visibilità vicino a chi sta già cercando.",
  lp2StoreBenefitsDesc: "Store è il modo semplice per inserire un'attività fisica nell'ecosistema.",
  lp2StoreBenefit1Title: "Appari sulla mappa",
  lp2StoreBenefit1Desc: "Aiuta le persone della tua zona a trovare la tua attività.",
  lp2StoreBenefit2Title: "Entra nella rete",
  lp2StoreBenefit2Desc: "Fai parte di una comunità di consumatori, venditori e promotori.",
  lp2StoreBenefit3Title: "Inizia senza costi",
  lp2StoreBenefit3Desc: "La registrazione Store è gratuita e pensata per facilitare l'ingresso delle attività locali.",
  lp2StoreLocalEyebrow: "Per le attività locali",
  lp2StoreLocalTitle: "La tua presenza fisica continua a contare.",
  lp2StoreLocalDesc: "Extraconomy usa la tecnologia per avvicinare le persone alle attività reali. Store aiuta il tuo negozio a far parte di questa scoperta locale.",
  lp2StoreLocalPhotoAlt: "Attività locale che serve un cliente",
  lp2StoreFaqEyebrow: "Domande rapide",
  lp2StoreFaqTitle: "Prima di continuare.",
  lp2StoreFaqDesc: "Guarda solo ciò che di solito genera dubbi in questa fase.",
  lp2StoreFaq1Q: "La registrazione Store è gratuita?",
  lp2StoreFaq1A: "Sì. Store è l'accesso gratuito per le attività fisiche.",
  lp2StoreFaq2Q: "Devo vendere online?",
  lp2StoreFaq2A: "No. Il profilo Store esiste per la presenza fisica. Se vuoi vendere online in seguito, puoi scoprire i piani Partner, Seller e Manager.",
  lp2StoreFaq3Q: "Il negozio appare alle persone vicine?",
  lp2StoreFaq3A: "La proposta del profilo include presenza geolocalizzata all'interno della rete, in base alle funzionalità disponibili sulla piattaforma.",
  lp2StoreCtaTitle: "Il tuo negozio può già farne parte.",
  lp2StoreCtaDesc: "Registra i dati di base dell'attività e inizia con il profilo gratuito Store.",
  lp2StoreCtaButton: "Registra negozio",
  lp2WhiteLabelSeoDescription: "Crea una rete tutta tua con l'infrastruttura White Label di Extraconomy.",
  lp2WhiteLabelBadge: "White Label",
  lp2WhiteLabelH1: "Una rete con l'identità della tua organizzazione.",
  lp2WhiteLabelHeroDesc: "Usa la tecnologia Extraconomy per riunire persone, attività e vantaggi in un ambiente tutto tuo.",
  lp2WhiteLabelCta1: "Voglio parlarne",
  lp2WhiteLabelCta2: "Scopri come funziona",
  lp2WhiteLabelBenefitsEyebrow: "La tua rete, la tua identità",
  lp2WhiteLabelBenefitsTitle: "La tecnologia resta dietro le quinte. La tua comunità resta in primo piano.",
  lp2WhiteLabelBenefitsDesc: "Associazioni, aziende e organizzazioni possono usare l'infrastruttura Extraconomy senza dover spiegare tutta la complessità tecnica ai propri partecipanti.",
  lp2WhiteLabelBenefit1Title: "Identità propria",
  lp2WhiteLabelBenefit1Desc: "L'esperienza può assumere l'identità visiva e la comunicazione dell'organizzazione.",
  lp2WhiteLabelBenefit2Title: "Rete di attività",
  lp2WhiteLabelBenefit2Desc: "Riunisci partecipanti e attività in un ambiente comune.",
  lp2WhiteLabelBenefit3Title: "Vantaggi collegati",
  lp2WhiteLabelBenefit3Desc: "Struttura vantaggi e relazioni secondo la logica del tuo ecosistema.",
  lp2WhiteLabelStepsEyebrow: "Dall'idea all'uso",
  lp2WhiteLabelStepsTitle: "Tre passi per iniziare.",
  lp2WhiteLabelStepsDesc: "L'implementazione può essere approfondita in seguito. Prima dobbiamo capire chi fa parte della tua rete e cosa deve rendere possibile.",
  lp2WhiteLabelStep1Label: "01 · Capire",
  lp2WhiteLabelStep1Title: "Chi fa parte della tua rete?",
  lp2WhiteLabelStep1Desc: "Partiamo dalle persone, attività e relazioni che già esistono.",
  lp2WhiteLabelStep2Label: "02 · Configurare",
  lp2WhiteLabelStep2Title: "Quali vantaggi hanno senso?",
  lp2WhiteLabelStep2Desc: "La struttura è organizzata intorno all'obiettivo dell'organizzazione.",
  lp2WhiteLabelStep3Label: "03 · Lanciare",
  lp2WhiteLabelStep3Title: "Un'esperienza semplice da usare.",
  lp2WhiteLabelStep3Desc: "La complessità tecnica resta dietro le quinte; la partecipazione deve restare chiara.",
  lp2WhiteLabelCtaTitle: "Vuoi creare una rete tutta tua?",
  lp2WhiteLabelCtaDesc: "Raccontaci chi riunisci e cosa vuoi rendere possibile.",
  lp2WhiteLabelCtaButton: "Parliamo di White Label",
  lp2PromoterSeoDescription: "Diventa Promotore Extraconomy e aiuta la rete a crescere nella tua zona.",
  lp2PromoterBadge: "Promotore · gratuito",
  lp2PromoterH1: "Collega buone attività alla rete.",
  lp2PromoterHeroDesc: "Il Promotore presenta Extraconomy, avvicina persone e aziende e aiuta l'ecosistema a crescere a livello locale.",
  lp2PromoterCta1: "Voglio essere Promotore",
  lp2PromoterCta2: "Capire il ruolo",
  lp2PromoterBenefitsEyebrow: "Cosa fai",
  lp2PromoterBenefitsTitle: "Tu apri le porte. La rete fa il resto.",
  lp2PromoterBenefitsDesc: "Il ruolo del Promotore è avvicinare nuove attività a Extraconomy e supportare il primo contatto con l'ecosistema.",
  lp2PromoterBenefit1Title: "Presenta l'idea",
  lp2PromoterBenefit1Desc: "Spiega in modo semplice come un'attività può entrare nella rete.",
  lp2PromoterBenefit2Title: "Crea connessioni reali",
  lp2PromoterBenefit2Desc: "Avvicina persone e aziende che possono generare valore reciproco.",
  lp2PromoterBenefit3Title: "Rafforza la tua zona",
  lp2PromoterBenefit3Desc: "Aiuta la rete a crescere con attività che esistono vicino a te.",
  lp2PromoterPayEyebrow: "Remunerazione",
  lp2PromoterPayTitle: "La remunerazione segue l'attività reale.",
  lp2PromoterPayDesc: "Le regole di remunerazione fanno parte del piano compensi e sono legate alle condizioni e alle attività previste da Extraconomy. La registrazione, da sola, non deve essere trattata come una vendita.",
  lp2PromoterChecklistTitle: "Prima di iniziare",
  lp2PromoterChecklist1: "Capisci come funziona Extraconomy per spiegarlo con chiarezza.",
  lp2PromoterChecklist2: "Collega attività che abbiano una reale aderenza alla rete.",
  lp2PromoterChecklist3: "Consulta il piano compensi prima di assumere qualsiasi aspettativa di guadagno.",
  lp2PromoterCtaTitle: "Vuoi aiutare la rete a crescere?",
  lp2PromoterCtaDesc: "Inizia dalla registrazione e conosci le regole prima di agire.",
  lp2PromoterCtaButton: "Voglio essere Promotore",
  lp2EmpresasSeoDescription: "Porta Extraconomy a collaboratori, clienti e partner con soluzioni di welfare, ESG e relazione B2B.",
  lp2EmpresasBadge: "Per le aziende",
  lp2EmpresasH1: "Vantaggi che hanno senso per chi è con te.",
  lp2EmpresasHeroDesc: "Porta Extraconomy a collaboratori, clienti e partner con soluzioni di welfare, ESG e relazione B2B.",
  lp2EmpresasCta1: "Parla con Extraconomy",
  lp2EmpresasCta2: "Scopri White Label",
  lp2EmpresasBenefitsEyebrow: "Soluzioni per le aziende",
  lp2EmpresasBenefitsTitle: "Una rete di vantaggi può iniziare in modi diversi.",
  lp2EmpresasBenefitsDesc: "Scegli il punto che si adatta alla tua strategia e approfondisci solo dove ha senso.",
  lp2EmpresasBenefit1Title: "Welfare e vantaggi",
  lp2EmpresasBenefit1Desc: "Crea vantaggi per le persone legate alla tua azienda.",
  lp2EmpresasBenefit2Title: "ESG con relazione locale",
  lp2EmpresasBenefit2Desc: "Avvicina consumo, attività e impatto all'interno di una rete più vicina.",
  lp2EmpresasBenefit3Title: "Relazioni B2B",
  lp2EmpresasBenefit3Desc: "Collega aziende e opportunità commerciali all'interno dell'ecosistema.",
  lp2EmpresasWhiteLabelEyebrow: "Anche per le associazioni",
  lp2EmpresasWhiteLabelTitle: "Vuoi una rete con l'identità della tua organizzazione?",
  lp2EmpresasWhiteLabelDesc: "La soluzione White Label usa l'infrastruttura Extraconomy per creare un ambiente tutto tuo di partecipanti, attività e vantaggi.",
  lp2EmpresasWhiteLabelLink: "Scopri White Label",
  lp2EmpresasStepEyebrow: "Un passo alla volta",
  lp2EmpresasStepTitle: "Inizia dal problema che la tua azienda vuole risolvere.",
  lp2EmpresasStepDesc: "La nostra conversazione parte dal bisogno: vantaggi, relazione, rete commerciale o ambiente tutto tuo.",
  lp2EmpresasCtaTitle: "Capiamo il tuo caso?",
  lp2EmpresasCtaDesc: "Raccontaci di cosa ha bisogno la tua azienda. La soluzione arriva dopo.",
  lp2EmpresasCtaButton: "Parla con il team",
  lp2PlanosSeoDescription: "Confronta Store, Partner, Seller e Manager su Extraconomy.",
  lp2PlanosBreadcrumb: "Piani",
  lp2PlanosEyebrow: "Piani",
  lp2PlanosH1: "Scegli in base alla dimensione della tua attività.",
  lp2PlanosHeroDesc:
    "Inizia gratis con Store o scegli una struttura di vendita online. Confronta solo ciò che cambia tra i piani.",
  lp2PlanosCompareEyebrow: "Confronto semplice",
  lp2PlanosCompareTitle: "Scopri le differenze che contano davvero.",
  lp2PlanosCompareDesc: "Se un piano ha senso per te, visita la sua pagina per conoscere i dettagli.",
  lp2PlanosStoreDesc: "Negozio fisico sulla mappa.",
  lp2PlanosStoreItem1: "Registrazione gratuita",
  lp2PlanosStoreItem2: "Account geolocalizzato",
  lp2PlanosStoreItem3: "Certificazione sulla mappa",
  lp2PlanosStoreCta: "Scopri Store",
  lp2PlanosPartnerDesc: "€150/anno · fino a 50 annunci.",
  lp2PlanosPartnerItem1: "Vetrina online",
  lp2PlanosPartnerItem2: "Rete economica",
  lp2PlanosPartnerItem3: "Rinnovo €15/anno",
  lp2PlanosPartnerCta: "Scopri Partner",
  lp2PlanosSellerDesc: "€350/anno · fino a 500 annunci.",
  lp2PlanosSellerItem1: "E-commerce personale",
  lp2PlanosSellerItem3: "Rinnovo €35/anno",
  lp2PlanosSellerCta: "Scopri Seller",
  lp2PlanosManagerDesc: "€1.500/anno · annunci illimitati.",
  lp2PlanosManagerItem1: "Negozio online",
  lp2PlanosManagerItem2: "Geolocalizzazione",
  lp2PlanosManagerItem3: "Rinnovo €150/anno",
  lp2PlanosManagerCta: "Scopri Manager",
  lp2PlanosDisclaimer: "Valori e condizioni devono essere confermati al momento dell'adesione.",
  lp2PlanosCtaTitle: "Hai ancora dubbi?",
  lp2PlanosCtaDesc: "Inizia con lo Store gratuito o scopri con calma ogni piano.",
  lp2PlanosCtaButton: "Inizia con Store",
  lp2SobreSeoDescription: "Scopri l'idea alla base di Extraconomy e come la sua rete collega persone e attività.",
  lp2SobreBadge: "Chi è Extraconomy",
  lp2SobreH1: "Una rete creata per far circolare il valore.",
  lp2SobreHeroDesc: "Extraconomy avvicina chi compra, chi vende e chi crea nuove connessioni per rafforzare relazioni economiche più vicine.",
  lp2SobreCta1: "Scopri dove mi inserisco",
  lp2SobreCta2: "Per le aziende",
  lp2SobreIdeaEyebrow: "La nostra idea",
  lp2SobreIdeaTitle: "La tecnologia ha senso solo quando migliora relazioni reali.",
  lp2SobreIdeaDesc: "Per questo Extraconomy riunisce marketplace, vantaggi, fidelizzazione e strumenti per aiutare persone, attività e organizzazioni a far parte della stessa rete.",
  lp2SobreValue1Title: "Le persone al centro",
  lp2SobreValue1Desc: "L'esperienza parte da ciò che qualcuno vuole fare, non dalla tecnologia che c'è dietro.",
  lp2SobreValue2Title: "Attività reali",
  lp2SobreValue2Desc: "Negozi fisici e venditori online fanno parte della stessa economia connessa.",
  lp2SobreValue3Title: "Valore in circolazione",
  lp2SobreValue3Desc: "I vantaggi incentivano nuove relazioni all'interno della rete stessa.",
  lp2SobreInfraEyebrow: "Da marketplace a infrastruttura",
  lp2SobreInfraTitle: "La stessa logica può servire persone, aziende e comunità.",
  lp2SobreInfraDesc: "Il marketplace è una parte importante. Extrapay, soluzioni aziendali e White Label estendono questa base ad altri contesti senza perdere l'idea centrale: collegare persone e attività in modo semplice.",
  lp2SobreInfraImgAlt: "Attività locale dell'economia Extraconomy",
  lp2SobreCtaTitle: "Dove ti inserisci in questa rete?",
  lp2SobreCtaDesc: "Scegli in base all'attività che ha senso per te oggi.",
  lp2SobreCtaButton: "Scopri i profili",
  lp2VideoEyebrow: "Scopri Extraconomy",
  lp2VideoTitle: "Un'economia che resta a chi partecipa.",
  lp2VideoDescription: "In pochi minuti il nostro fondatore presenta l'ecosistema che unisce cittadini, negozianti, professionisti e associazioni in un'unica rete di vantaggi.",
  lp2VideoLanguageNote: "",
  lp2VideoPlay: "Guarda il video",
};

export default landingDictIT;
